











































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {PostProductBulkImagesRequest, ProductBulkImageInfo} from 'supporter';
import {ncpPopup} from '@/utils/ncp';
import store from '@/store';
import {toI18n} from '@/utils/commonUtils';
import LayerPopup from '@/components/LayerPopup.vue';

enum IMAGE_UPLOAD_SETTING {
  FILE_NAME = 'FILE_NAME',
  IMAGE_TYPE_NUMBERING = 'IMAGE_TYPE_NUMBERING'
}

enum FILE_NAME_SETTING {
  MALL_PRODUCT_NO = 'MALL_PRODUCT_NO',
  PRODUCT_MANAGEMENT_CD = 'PRODUCT_MANAGEMENT_CD'
}

interface UploadSetting {
  imageUpload: IMAGE_UPLOAD_SETTING;
  fileName: FILE_NAME_SETTING;
}

enum IMAGE_UPLOAD_MESSAGE {
  OK = 'callbackOk',
  CANCEL = 'callbackCancel',
  COMPLETE = 'callbackComplete'
}

enum IMAGE_UPLOAD_TYPE {
  DEFAULT,
  PRODUCT,
  LIST,
  TOP_DETAIL,
  DETAIL,
  BOTTOM_DETAIL
}

interface ImageTypeData {
  title: string;
  maxLength: number;
  maxSize: number;
  check?: boolean;
  requestLength: number;
  imageList: ProductBulkImageInfo[];
}

interface ImageSuccessData {
  bytes: number;
  createdBy: string;
  id: string;
  imageProperty: {
    width: number;
    height: number;
    coordinate: {
      lat: number;
      lng: number;
    };
    createdAt: string;
  };
  isFolder: boolean;
  name: string;
  operationId: string;
  path: string;
  queues: [];
  updatedAt: string;
  url: string;
}

interface ImageErrorData {
  bytes: number;
  error: {
    resultCode: number;
    resultMessage: string;
  };
  path: string;
}

interface ImageData {
  type: IMAGE_UPLOAD_MESSAGE;
  response: {
    errors: ImageErrorData[];
    successes: ImageSuccessData[];
  };
  path: string;
}

interface MessageEvent extends Event {
  data: ImageData;
  origin: string;
}

interface ViewTrData {
  uploadKey: string;

  title: string;
  number: string;
  size: string;
  bUpload: boolean;
  bSameCheck?: boolean;
}

@Component({
  components: {
    LayerPopup
  }
})
export default class ProductBulkImageUpload extends Vue {
  private uploadSetting: UploadSetting = {
    imageUpload: IMAGE_UPLOAD_SETTING.FILE_NAME,
    fileName: FILE_NAME_SETTING.MALL_PRODUCT_NO
  };
  private popup: Window | null = null;

  private uploadData: Map<IMAGE_UPLOAD_TYPE, ImageData> = new Map();
  private uploadKey: IMAGE_UPLOAD_TYPE = IMAGE_UPLOAD_TYPE.DEFAULT;
  private imageInfos = {
    totalNum: 0,
    num: 0
  };
  @Watch('bPossibleRegisterButton')
  uploadKeyChange() {
    if (!this.isFileNameSetting()) {
      if (this.bPossibleRegisterButton) {
        $('input[name=imageUploadType]').prop('disabled', true);
        $('input[name=imageNamingType]').prop('disabled', true);
      } else {
        $('input[name=imageUploadType]').prop('disabled', false);
        $('input[name=imageNamingType]').prop('disabled', false);
      }
    }
  }
  private viewTrData: ViewTrData[] = [
    {uploadKey: 'PRODUCT', title: this.toI18n('INDIVIDUAL_GUIDE_IMAGE'), number: this.toI18n('GUIDE_MAX_NUMBER_10'), size: this.toI18n('GUIDE_MAX_SIZE_1_2'), bUpload: false},
    {uploadKey: 'LIST', title: this.toI18n('GUIDE_IMAGE_3'), number: this.toI18n('GUIDE_MAX_NUMBER_1'), size: this.toI18n('GUIDE_MAX_SIZE_1'), bUpload: false},
    {uploadKey: 'TOP_DETAIL', title: this.toI18n('GUIDE_IMAGE_4'), number: this.toI18n('GUIDE_MAX_NUMBER_9'), size: this.toI18n('GUIDE_MAX_SIZE_10_2'), bUpload: false},
    {uploadKey: 'DETAIL', title: this.toI18n('GUIDE_IMAGE_5'), number: this.toI18n('GUIDE_MAX_NUMBER_9'), size: this.toI18n('GUIDE_MAX_SIZE_10_2'), bUpload: false, bSameCheck: false},
    {uploadKey: 'BOTTOM_DETAIL', title: this.toI18n('GUIDE_IMAGE_6'), number: this.toI18n('GUIDE_MAX_NUMBER_9'), size: this.toI18n('GUIDE_MAX_SIZE_10_2'), bUpload: false}
  ];

  private bSameImage: boolean = false;
  private bPossibleRegisterButton: boolean = true;

  private isLayerPopup: boolean = false;
  private layerPopupData = {
    id: 'bulkImageResultPopup',
    width: 500,
    title: '',
    hasConfirmBtn: false,
    noTitle: true
  };
  private layerClose() {
    $('body').removeClass('no-scroll');
  }
  private isFileNameSetting(): boolean {
    return this.uploadSetting.imageUpload === IMAGE_UPLOAD_SETTING.FILE_NAME;
  }
  private isProductNoSetting(): boolean {
    return this.uploadSetting.fileName === FILE_NAME_SETTING.MALL_PRODUCT_NO;
  }
  private changeUploadSetting(key: string): void {
    if (IMAGE_UPLOAD_SETTING[key] !== undefined) {
      this.uploadSetting.imageUpload = IMAGE_UPLOAD_SETTING[key];
    } else if (FILE_NAME_SETTING[key] !== undefined) {
      this.uploadSetting.fileName = FILE_NAME_SETTING[key];
    }

    this.bSameImage = false;
    this.isPossibleRegisterButton();
  }
  private getIndividualUploadLength(key: string): string {
    const data = this.uploadData.get(IMAGE_UPLOAD_TYPE[key]);

    if (data) {
      const length = data.response.successes.length + data.response.errors.length;
      return length > 0 ? length + this.toI18n('MAX_NUMBER_UNIT') : '-';
    } else {
      return '-';
    }
  }
  private isPossibleRegisterButton(): void {
    this.bPossibleRegisterButton = true;

    if (!this.isFileNameSetting()) {
      for (let i = 0; i < this.viewTrData.length; i++) {
        this.bPossibleRegisterButton = this.viewTrData[i].bUpload;
        if (this.viewTrData[i].bUpload) {
          break;
        }
      }
    }
  }

  created() {
    window.addEventListener('message', this.receiveMessage);
  }
  destroyed() {
    window.removeEventListener('message', this.receiveMessage);
  }

  /**
   * get image upload popup url
   */
  private getProductBulkImagesUploadInfo(): Promise<string> {
    return this.$api
      .getProductBulkImagesUploadInfo()
      .then((response) => {
        let url = '';

        if (response && response.status === 200 && response.data && response.data.url) {
          url = response.data.url;
        }

        return url;
      })
      .catch(() => {
        return '';
      });
  }

  /**
   * post product bulk images
   */
  private postProductBulkImages(): Promise<boolean> {
    const imageInfos = this.getUploadImageInfos();
    const request: PostProductBulkImagesRequest = {
      data: {
        imageNamingType: this.uploadSetting.fileName,
        imageInfos: imageInfos.list,
        imageUploadType: this.uploadSetting.imageUpload
      }
    };

    return this.$api
      .postProductBulkImages(request)
      .then((response) => {
        if (response && response.status === 202) {
          this.isLayerPopup = true;
          this.imageInfos.totalNum = imageInfos.totalNum;
          this.imageInfos.num = imageInfos.list.length;
          $('body').addClass('no-scroll');
          return true;
        }

        return false;
      })
      .catch(() => {
        return false;
      });
  }

  /**
   * make upload image infos data (for postProductBulkImages)
   */
  private getUploadImageInfos(): {list: ProductBulkImageInfo[]; totalNum: number} {
    const list: ProductBulkImageInfo[] = [];
    let totalNum = 0;

    if (this.uploadKey === IMAGE_UPLOAD_TYPE.DEFAULT) {
      const imageData = this.uploadData.get(this.uploadKey);

      imageData.response.successes.forEach((item) => {
        list.push({
          bytes: item.bytes,
          name: item.name,
          url: item.url,
          originName: item.name
        });
      });

      totalNum = imageData.response.successes.length + imageData.response.errors.length;
    } else {
      this.uploadData.forEach((imageData: ImageData, key: IMAGE_UPLOAD_TYPE) => {
        if (key !== IMAGE_UPLOAD_TYPE.DEFAULT) {
          imageData.response.successes.forEach((item) => {
            const convertItem: ProductBulkImageInfo = {
              bytes: item.bytes,
              name: '',
              url: item.url,
              originName: item.name
            };
            if (key === IMAGE_UPLOAD_TYPE.LIST) {
              const match = item.name.match(/^([0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣 ]+)\.(\w*)$/);
              if (match) {
                convertItem.name = match[1] + '_list.' + match[2];
              }
            } else {
              const match = item.name.match(/^([0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣 ]+)-([0-9]{1})\.(\w*)$/);

              if (match) {
                switch (key) {
                  case IMAGE_UPLOAD_TYPE.PRODUCT:
                    if (match[2] === '0') {
                      convertItem.name = match[1] + '_main.' + match[3];
                    } else {
                      convertItem.name = match[1] + '_add_' + match[2] + '.' + match[3];
                    }
                    break;
                  case IMAGE_UPLOAD_TYPE.TOP_DETAIL:
                    convertItem.name = match[1] + '_top_' + match[2] + '.' + match[3];
                    break;
                  case IMAGE_UPLOAD_TYPE.DETAIL:
                    if (this.bSameImage) {
                      convertItem.name = match[1] + '_detailcopy_' + match[2] + '.' + match[3];
                    } else {
                      convertItem.name = match[1] + '_detail_' + match[2] + '.' + match[3];
                    }
                    break;
                  case IMAGE_UPLOAD_TYPE.BOTTOM_DETAIL:
                    convertItem.name = match[1] + '_down_' + match[2] + '.' + match[3];
                    break;
                }
              }
            }

            list.push(convertItem);
          });

          totalNum += imageData.response.successes.length + imageData.response.errors.length;
        }
      });
    }

    return {list, totalNum};
  }

  /**
   * receive message from image upload popup
   *
   * - OK : click confirm button in popup
   * - CANCEL : click cancel button in popup
   * - COMPLETE : complete upload image in popup
   */
  private receiveMessage(e: MessageEvent): void {
    const {data, origin} = e;

    if (!data || !origin) {
      return;
    }

    if (origin.indexOf('product.cloud.toast.com') !== -1) {
      if (data.type === IMAGE_UPLOAD_MESSAGE.OK) {
        this.closeImageUploadPopup();
      } else if (data.type === IMAGE_UPLOAD_MESSAGE.CANCEL) {
        this.closeImageUploadPopup();
      } else if (data.type === IMAGE_UPLOAD_MESSAGE.COMPLETE) {
        this.saveImageInfos(data);

        if (this.isFileNameSetting()) {
          this.postProductBulkImages();

          // this.closeImageUploadPopup();
        }
      }
    }
  }

  /**
   * save image info data
   */
  private saveImageInfos(imageData: ImageData): void {
    this.uploadData.set(this.uploadKey, imageData);
    this.uploadData = new Map<IMAGE_UPLOAD_TYPE, ImageData>(this.uploadData);

    this.viewTrData.forEach((item) => {
      if (IMAGE_UPLOAD_TYPE[item.uploadKey] === this.uploadKey) {
        item.bUpload = true;
      }
    });
    this.isPossibleRegisterButton();
  }

  private removeImageInfos(bClear: boolean = false): void {
    if (bClear) {
      this.uploadData.clear();
      this.viewTrData.forEach((item) => {
        item.bUpload = false;
      });
    } else {
      this.uploadData.delete(this.uploadKey);
      this.viewTrData.forEach((item) => {
        if (IMAGE_UPLOAD_TYPE[item.uploadKey] === this.uploadKey) {
          item.bUpload = false;
        }
      });
    }
    this.isPossibleRegisterButton();
  }

  /**
   * regist images
   */
  private registImages(): void {
    if (this.isFileNameSetting()) {
      this.getProductBulkImagesUploadInfo().then((url) => {
        this.openImageUploadPopup(url);
      });
    } else {
      this.postProductBulkImages().then((success: boolean) => {
        if (success) {
          this.removeImageInfos(true);
          this.bSameImage = false;
        }
      });
    }
  }

  /**
   * upload individual image (main, list, detail ....)
   */
  private uploadIndividualImage(key: string): void {
    alert(this.toI18n('ALERT_UPLOAD_INDIVIDUAL'));

    this.uploadKey = IMAGE_UPLOAD_TYPE[key];

    this.getProductBulkImagesUploadInfo().then((url) => {
      this.openImageUploadPopup(url);
    });
  }

  /**
   * reset individual image (main, list, detail ....)
   */
  private resetIndividualImage(key: any | null): void {
    if (!key) {
      this.uploadSetting.imageUpload = IMAGE_UPLOAD_SETTING.FILE_NAME;
      this.uploadSetting.fileName = FILE_NAME_SETTING.MALL_PRODUCT_NO;
      this.removeImageInfos(true);
      $('input[name=imageUploadType]').prop('disabled', false);
      $('input[name=imageNamingType]').prop('disabled', false);
      return;
    }
    if (key&&key.bUpload) {
      if (confirm(this.toI18n('CONFIRM_RESET_INDIVIDUAL'))) {
        this.uploadKey = IMAGE_UPLOAD_TYPE[key.uploadKey] as any;
        this.removeImageInfos();
      }
    }
  }

  private changeSamecheck(e: Event): void {
    if (!this.bSameImage) {
      const productData: ImageData = this.uploadData.get(IMAGE_UPLOAD_TYPE.PRODUCT);
      if (!productData || productData.response.successes.length === 0) {
        alert(this.toI18n('ALERT_REQUEST_PRODUCT_IMAGE'));
        e.preventDefault();
        return;
      }

      this.uploadKey = IMAGE_UPLOAD_TYPE.DETAIL;
      this.saveImageInfos({...productData});
    } else {
      this.uploadKey = IMAGE_UPLOAD_TYPE.DETAIL;
      this.removeImageInfos();
    }
  }

  private openGuidePopup(): void {
    ncpPopup('/product/bulkImage/uploadInfo', '_blank');
  }

  /**
   * Toast Popup Open
   */
  private openImageUploadPopup(url: string): void {
    if (url !== '') {
      this.popup = ncpPopup(url, '_blank', 1000, 670);
      store.commit('SET_DIMMEDAREA', true);
      this.checkImageUploadPopupAlive();
    }
  }

  /**
   * Toast Popup Close
   */
  private closeImageUploadPopup(): void {
    if (this.popup && !this.popup.closed) {
      this.popup.close();
    }

    store.commit('SET_DIMMEDAREA', false);
  }

  /**
   * Check Toast Popup Alive
   * - if press window x, not receive message. so interval check
   */
  private checkImageUploadPopupAlive(): void {
    setTimeout(() => {
      if (this.popup) {
        if (this.popup.closed) {
          this.closeImageUploadPopup();
        } else {
          this.checkImageUploadPopupAlive();
        }
      }
    }, 1000);
  }

  private toI18n(needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'PRODUCT_BULK_IMAGE_') + needToI18nStr));
  }
}
